import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-redo-icon',
  templateUrl: './text-redo.component.html'
})
export class TextRedoComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
